export default __webpack_public_path__ + "static/media/webView.91b2f9fe.png";